import { produce } from 'immer';

import { CancelUploadInternalBannerImage } from '../../../actions/imageEditor/internal/cancelUploadInternalBannerImage';
import { getImageEditorIdByBannerId } from '../../../service/ImageHelpers/ImageHelpers';
import { ImageOrCreativeUploadingMode } from '../../../typings/banners';
import { ImageEditorsState } from '../../../typings/state';

export function cancelUploadInternalBannerImage(
    state: ImageEditorsState,
    action: CancelUploadInternalBannerImage
): ImageEditorsState {
    const id = getImageEditorIdByBannerId(action.bannerId, action.resourceId);

    return produce(state, draft => {
        draft[id].image.mode = ImageOrCreativeUploadingMode.EMPTY;
        draft[id].image.displayName = '';
        draft[id].image.uploadingData = undefined;
        draft[id].image.errors = undefined;
    });
}
